import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { ConfigComponents } from '../../config/features/config';
import { useCommon } from 'src/domains/common/Common';
import { GamblingSafetyTopBar } from 'src/domains/layouts/webview/components/gamblingSafetyTopBar/GamblingSafetyTopBar';

export const GamblingSafetyBar = observer('GamblingSafetyBar', () => {
    const common = useCommon();
    const config = ConfigComponents.get(common).config;

    const { isSaferGambling } = config;
    if (isSaferGambling.available && isSaferGambling.hasTopBar) {
        return <GamblingSafetyTopBar />;
    } else {
        return null;
    }
});
